import storeEvent from '../../utils/store-event';

const SEL = {
    content: '.str-left-nav__content'
};
const CLS = {
    open: 'open',
    fixed: 'fixed'
};

export default class {
    onMount() {
        this.root = this.getEl('str-left-nav');
        this.contentEl = this.root.querySelector(SEL.content);
        this.links = this.root.querySelectorAll('a');
        this.buttons = this.root.querySelectorAll('button');
        this.currentTabIndex = 0;
        this.handleToggle();
        this.handleStickyHeader();
        this.handleTabChange();
        this.observeGlobalFooterIntersection();
        this.setFocusability(false);
    }
    handleTabChange() {
        storeEvent.tabHasChanged.listen(data => {
            this.currentTabIndex = data.tabIndex;
        });
    }
    handleToggle() {
        storeEvent.toggleLeftNav.listen(() => {
            // Open leftNav from tab other than "Shop" tab.
            if (this.currentTabIndex !== 0) {
                storeEvent.changeToTab.dispatch({ tabIndex: 0, skipFocus: true });
                this.root.classList.add(CLS.open);
            } else { // Toggle leftNav from "Shop"  tab.
                this.root.classList.toggle(CLS.open);
            }

            // Now handle the things related to being open or closed
            const isOpen = this.root.classList.contains(CLS.open);
            this.root.setAttribute('aria-hidden', !isOpen);
            this.setFocusability(isOpen);
            storeEvent.toggleLeftNavDone.dispatch({ isOpen });
        });
    }
    setFocusability(makeFocusable) {
        const tabIndex = makeFocusable ? 0 : -1;
        for (let i = 0, n = this.links.length; i < n; i++) {
            this.links[i].tabIndex = tabIndex;
        }
        for (let i = 0, n = this.buttons.length; i < n; i++) {
            this.buttons[i].tabIndex = tabIndex;
        }
    }
    handleStickyHeader() {
        storeEvent.stickyHeaders.listen(data => {
            if (data.isSticky) {
                this.contentEl.classList.add(CLS.fixed);
            } else {
                this.contentEl.classList.remove(CLS.fixed);
            }
        });
    }
    // The content element of the leftNav goes to the bottom of the viewport.
    // When the global footer is scrolled into view, it can mask some of the
    // content. The solve for this is to add padding-bottom to the content
    // element to bump it above the global footer so that it's visible.
    observeGlobalFooterIntersection() {
        const globalFooter = document.querySelector('.global-footer');
        const extraPad = 40;
        if (window.IntersectionObserver) {
            const callback = (entries) => {
                // The body.offsetHeight needs to be greater than 0.
                // This is an issue on the Store Management preview layer, where the page is
                // loaded in an iframe. When the mweb iframe is on the hidden tab panel, the body
                // has zero height. When that's the case, we shouldn't do anything.
                if (document.body.offsetHeight > 0) {
                    const { isIntersecting } = entries[0];
                    if (isIntersecting) {
                        this.contentEl.style.paddingBottom = `${globalFooter.offsetHeight + extraPad }px`;
                    } else {
                        this.contentEl.style.paddingBottom = null;
                    }
                }
            };
            new IntersectionObserver(callback).observe(globalFooter);
        }
    }
}
